import React, { useState, useEffect } from 'react';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Controller } from 'react-hook-form';

import './style.scss';

const defaultInputStyle = {
  backgroundColor: 'white',
  boxSizing: 'border-box',
  height: 40,
  fontSize: 16,
  paddingRight: '2px !important',
  width: '100%',
};

export function EeSelect(props: any) {
  const [valueState, setValueState] = useState(props.value);

  useEffect(() => {
    if (valueState !== props.value) {
      setValueState(props.value);
    }
  }, [props.value]);

  const {
    inputStyle = defaultInputStyle,
    control,
    disabled,
    defaultValue,
  } = props;
  return props.register ? (
    <Controller
      as={
        <Select
          displayEmpty
          variant="outlined"
          style={inputStyle}
          defaultValue={defaultValue}
          disabled={disabled}
          inputProps={{
            onChange: (e) => props.onChange(e),
          }}
        >
          <MenuItem value="-1">None</MenuItem>
          {props?.items?.map((item: any, index: number) => {
            return (
              <MenuItem key={index} value={item.id}>
                {item.name}
              </MenuItem>
            );
          })}
        </Select>
      }
      name={props.name}
      control={control}
      defaultValue={defaultValue}
    />
  ) : (
    <Select
      displayEmpty
      variant="outlined"
      style={inputStyle}
      value={valueState}
      disabled={disabled}
      onChange={(e) => {
        props.onChange(e);
      }}
    >
      <MenuItem value="">None</MenuItem>
      {props?.items?.map((item: any, index: number) => {
        return (
          <MenuItem key={index} value={item.id}>
            {item.name}
          </MenuItem>
        );
      })}
    </Select>
  );
}
